import { api } from "@/app/api";

export const createEvent = async (options) => {
  let response;
  try {
    response = (
      await api.post("/v1/events", {
        ...options,
      })
    ).data;
  } catch (error) {
    console.log(error);
  } finally {
    return response;
  }
};

export const getAnimals = async () => {
  try {
    const { data } = await api.get("/v1/animals");
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getEvents = async () => {
  try {
    const { data } = await api.get("/v1/events");
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateEvent = async (options) => {
  try {
    const { data } = await api.put("/v1/events", { ...options });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const { data } = await api.delete("/v1/events", { data: { eventId } });
    return data;
  } catch (error) {
    console.error(error);
  }
};
